import { Form } from "antd";
import { BaseModalRef } from "components/BaseModal";
import message from "components/CustomMessage";
import { FindingBucketContextType } from "contexts/FindingBucketContext";
import React, { forwardRef } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { FieldTypes } from "utils/formUtils";

import BulkUpdatePopup from "./BulkUpdatePopup";

type Props = {
  afterClose: () => void;
  bucket: FindingBucketContextType;
};

const DetachTicketsPopup = forwardRef<BaseModalRef, Props>(
  ({ afterClose, bucket }, ref) => {
    const [form] = Form.useForm();

    const handleOnOk = async (data: any) => {
      let _data = {
        ...data,
        detachTicket: true,
      };

      await bucket.submit(_data, FindingAPI.bulk.detachTicket);

      message.success(
        `Tickets detached from ${bucket.totalCount} finding(s). Please check after some time`,
      );
    };

    const fields = [
      {
        value: (
          <span className="text-bold">
            Are you sure you want to detach {bucket.totalCount} tickets?
          </span>
        ),
        type: FieldTypes.LABEL,
      },
    ];

    const modalProps = {
      okText: `Detach ${bucket.totalCount} tickets`,
    };

    return (
      <BulkUpdatePopup
        title={"Detach tickets"}
        form={form}
        onOk={handleOnOk}
        bucket={bucket}
        fields={fields}
        modalProps={modalProps}
        afterClose={afterClose}
        ref={ref}
      />
    );
  },
);

export default DetachTicketsPopup;
